export default {
  credit_expert: 'CreditExpert',
  identity: 'Identity Plus',
  basic: 'Free',
};
